import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const IntegrationEventsService = {
    apply: async (payload) => axios.post(API_URL + "/integration_events/apply", payload).then(({ data }) => data).catch((err) => { throw err }),
};

export default IntegrationEventsService;